module.exports = __webpack_public_path__ + "static/media/verify.336d6b94.png";